import { QuestionStateMachineData, QuestionScore, resetQuestionAnswerAndEvaluation } from '../data'

export class SolutionShownState {
  public readonly name = 'solution-shown'

  constructor(private data: QuestionStateMachineData,
              private questionScore: QuestionScore) {
  }

  stateEvents: {
    onReset: () => void
  }

  reset() {
    resetQuestionAnswerAndEvaluation(this.data, this.questionScore)
    this.stateEvents.onReset()
  }
}
